export default {
  // TODO global actions
}
